// extracted by mini-css-extract-plugin
module.exports = {"container_list_cabs":"discovercabs_container_list_cabs__1T3J_"};